<template>
  <ConfigProvider>
    <div
      class="p-4 absolute bottom-0 right-0 max-w-xs bg-red-100 w-full z-50 text-black text-sm space-y-0.5"
      :class="{ 'hidden': !showLogs }"
    >
      IsInsideWorkspace: {{ IsInsideWorkspace }}
    </div>
    <RouterView v-if="showRouterView" />
  </ConfigProvider>
</template>
<script setup lang="ts">
import { ConfigProvider } from 'reka-ui'
import { useAuthStore, useAppStore } from "@/stores";
import { storeToRefs } from 'pinia'
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute()
const authStore = useAuthStore();
const appStore = useAppStore();
const { profileLoaded } = storeToRefs(authStore);
const { IsInsideWorkspace } = storeToRefs(appStore);
const showLogs = ref(false)

// Show router view for public routes (e.g. vendor onboarding) even when profile isn't loaded
const showRouterView = computed(() => profileLoaded.value || !route.meta.auth)
</script>
